
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class PuNutshells extends Vue {
  @Prop({ required: true })
    nutshells!: string[]

  @Prop({ default: false })
    withJumpLink: boolean

  scrollOptions = {
    target: '#description',
    options: {
      duration: 200,
      offset: 0,
      callback: async () => {
        await this.$router.replace({ hash: '#description' })
      },
    },
  }
}
